export default __webpack_public_path__ + "static/media/trr-food-handheld-chickenbreakfast.b9cf58dd.png";